export const years = (() => {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];

    for (let year = currentYear; year >= 1900; year--) {
        yearsArray.push({ value: year, label: year });
    }

    return yearsArray;
})();
